import styled from 'styled-components'

export const AppDiv = styled.div`
    display: flex;

    .content {
        flex: 6;
        background-color: #f0f1f3;
    }
`